import { DatePipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ListeClientsService } from '../liste-clients.service';
import { ButtonComponent } from '@shared/components/button';
import { TooltipDirective } from '@shared/directives/tooltip';

// Bande repliée de l'historique, toujours visible en haut de l'écran : elle répond à la seule
// question qu'on se pose en arrivant — « y a-t-il eu une modification récente ? ». Le journal
// complet vit dans un panneau qu'on ouvre à la demande, une consultation étant ponctuelle
@Component({
  selector: 'app-historique-resume',
  imports: [DatePipe, ButtonComponent, TooltipDirective],
  templateUrl: './historique-resume.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './historique-resume.component.scss',
})
export class HistoriqueResumeComponent {
  private listeClientsService = inject(ListeClientsService);

  protected derniereModification = this.listeClientsService.derniereModification;
  protected nombreModifications = this.listeClientsService.nombreModifications;
  protected chargementEnCours = this.listeClientsService.chargementHistoriqueEnCours;

  protected ouvrir(): void {
    this.listeClientsService.ouvrirHistorique();
  }

  // Une action sans client est globale : son impact vaut pour tous les clients
  protected libelleClient(identifiantClient: string | undefined): string {
    return identifiantClient ?? 'tous les clients';
  }
}
